import angular from 'angular';
import autocompleteComponent from './ingredient-autocomplete.component';

export default angular.module('common.autocomplete.ingredient', [])
  .component('ingredientAutocomplete', autocompleteComponent)
  .value('EventEmitter', payload => ({ $event: payload }))
  .name;



// WEBPACK FOOTER //
// ./components/app/common/autocomplete/ingredient/ingredient-autocomplete.module.js